export default __webpack_public_path__ + "media/4.a7a15.png";